import React from 'react';
import history from 'app/routes/history';
import _ from 'lodash';

import * as paymentsSelectors from 'app/ducks/payments/selectors';

import { Card } from 'reactstrap';
import Button from 'app/components/general/Button';
import Tbody from 'app/components/general/Tbody';
import PaymentRow from 'app/components/teamPaymentRequests/PaymentRow';
import PaymentsTable from 'app/components/teamPaymentRequests/PaymentsTable';
import {
  IPaymentsSelector,
  IClubsSelector,
  ITeamsSelector,
  IRemindersSelector,
} from 'javascript/types/selector';

interface IManageClubPaymentsProps {
  appReady: boolean;
  actions: any;
  clubs: IClubsSelector;
  teams: ITeamsSelector;
  payments: IPaymentsSelector;
  reminders: IRemindersSelector;
}
export default class ManageClubPayments extends React.Component<
  IManageClubPaymentsProps
> {
  static defaultProps: IManageClubPaymentsProps = {
    appReady: false,
    actions: undefined,
    clubs: undefined,
    teams: undefined,
    payments: undefined,
    reminders: undefined,
    isLoading: false,
  };

  componentDidMount(): void {
    this.props.actions.getAllPayments(
      {
        filter: { 'club-id': this.props.clubs.currentClubId },
      },
      false,
    );
  }

  handleCollect = (e): void => {
    e.preventDefault();
    history.push('/payment-requests/new');
  };

  // relevantPaymentCollections(paymentId): any {
  //   return this.props.paymentCollectionsById.filter(
  //     (t) => t.payment.id === paymentId,
  //   );
  // }

  // renderPaymentRow(paymentId): React.ReactNode {
  //   const payment = this.props.paymentsById[paymentId];
  //   return (
  //     <PaymentRow
  //       key={payment.id}
  //       identifier={payment.id}
  //       payment={payment}
  //       team={payment.team}
  //       selectPayment={this.props.actions.selectPayment}
  //       createReminder={this.props.actions.createReminder}
  //       reminders={this.props.reminders}
  //       amount={payment.amount}
  //       payments={0}
  //       total={payment.total}
  //       pendingTeamMembers={payment.pending}
  //       collectedTeamMembers={payment.collected}
  //     />
  //   );
  // }

  // renderPaymentList(): React.ReactNode {
  //   if (this.props.paymentIds !== undefined) {
  //     return this.props.paymentIds.map((id) => this.renderPaymentRow(id));
  //   }
  //   return null;
  // }

  render(): React.ReactNode {
    const {
      paymentsById,
      paymentIds,
    } = paymentsSelectors.getPaymentsFilteredByClubById(
      this.props.payments.paymentsById,
      this.props.clubs.currentClubId,
    );

    return (
      <div className="h-100 m-h-100">
        <div className="row">
          <div className="col">
            <PaymentsTable
              {...this.props.payments}
              paymentsById={paymentsById}
              paymentIds={paymentIds}
              actions={this.props.actions}
              appReady={this.props.appReady}
              persistentFilterConfig={{
                clubId: this.props.clubs.currentClubId,
              }}
              selectPayment={this.props.actions.selectPayment}
              handleCreate={this.handleCollect}
            />
          </div>
        </div>
      </div>
    );
  }
}
